export default __webpack_public_path__ + "static/media/wallet-cropped.b2e00e6c.webp";